import React, { useState } from "react";
import "../Styles/About.css";

const About = ({ children }) => {
  const text = children;
  const [showReadMore, setShowReadMore] = useState(false);
  return (
    <div className="container-fluid py-4 px-0 my-4" >
      <h1 className="title text-center"> <span className="dark-blue">A</span><span className="light-blue">B</span><span className="dark-blue">O</span><span className="light-blue">U</span><span className="dark-blue">T</span><span className="light-blue"> U</span><span className="dark-blue">S</span></h1>
      <hr/>
      <div className="rows p-4" >
        <div className="column">
          <div className="img text-center">
            <img src="Images/Founder.jpg" alt="" className="founder-img" />
            <p className="mt-3 pt-3"><b style={{fontSize:'18px'}}>Bipin Gala</b> <br /> (Founder)</p>
          </div>
        </div>

        <div className="column d-flex align-items-center px-4">
          <p className="content my-3">
            {showReadMore ? text : text.slice(0, 600)}
            <div className=" my-2">
              <button
                type="button"
                className="read-more"
                onClick={() => setShowReadMore(!showReadMore)}
              >
                {showReadMore ? "Read Less" : "Read More"}
              </button>
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
